import { render, staticRenderFns } from "./PropertyListSkeleton.vue?vue&type=template&id=03911f12&"
import script from "./PropertyListSkeleton.vue?vue&type=script&lang=js&"
export * from "./PropertyListSkeleton.vue?vue&type=script&lang=js&"
import style0 from "./PropertyListSkeleton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
